(function (window) {
  'use strict';
  window.LEAVES_CONFIGURATOR_FIXTURES = {
  "generatedAt": "2026-10-13T03:34:36.925Z",
  "source": "leaves-lighting / leaves-lnt published variants, grouped by installation",
  "installations": {
    "wrap_around": {
      "id": "wrap_around",
      "handle": "outdoor-wrap-around-light-color-bridge",
      "cartVariantId": "47819810177250",
      "pluginOptionSetId": "165144",
      "family": "color_bridge",
      "fixturesByShape": {
        "basic": [
          {
            "id": "CQA-HW-YQPC12-10W",
            "label": "CQA-HW-YQPC12-10W",
            "sku": "CQA-HW-YQPC12-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HW-YQPC12-10W_8b4011e6-d772-4150-bb08-2cb71ebd27c6.jpg?v=1787899933",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808339170",
            "variantId": "67673808339170",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HW-YQPC15-13W",
            "label": "CQA-HW-YQPC15-13W",
            "sku": "CQA-HW-YQPC15-13W",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808371938",
            "variantId": "67673808371938",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-SZ-10W",
            "label": "CQA-SZ-10W",
            "sku": "CQA-SZ-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-SZ-10W_1a4e68e1-de34-4325-8bf3-23d8831c58f4.jpg?v=1787899934",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808470242",
            "variantId": "67673808470242",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-XBJW-7W",
            "label": "CQA-XBJW-7W",
            "sku": "CQA-XBJW-7W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-XBJW-7W_cdd3c78c-dca0-4fa0-96dd-c1ba7f203345.jpg?v=1787899935",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808503010",
            "variantId": "67673808503010",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSB-9W",
            "label": "CQA-HSB-9W",
            "sku": "CQA-HSB-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSB-9W_b9add07a-10ad-45a2-b860-35074383e8ee.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808535778",
            "variantId": "67673808535778",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSC-9W",
            "label": "CQA-HSC-9W",
            "sku": "CQA-HSC-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-9W_634ae9e1-5c4d-4c21-8faf-00cebef62e18.jpg?v=1787899931",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808568546",
            "variantId": "67673808568546",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSF-9W",
            "label": "CQA-HSF-9W",
            "sku": "CQA-HSF-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-9W_0ec5abbc-6376-4fbf-a77c-654135f974af.jpg?v=1787899940",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808634082",
            "variantId": "67673808634082",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSSJZ-9W",
            "label": "CQA-HSSJZ-9W",
            "sku": "CQA-HSSJZ-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-9W_c7b0ab60-e47f-41b8-971f-e5480033d963.jpg?v=1787899938",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808699618",
            "variantId": "67673808699618",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSC-9W-BS",
            "label": "CQA-HSC-9W-BS",
            "sku": "CQA-HSC-9W-BS",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-9W-BS.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808863458",
            "variantId": "67673808863458",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSF-9W-BS",
            "label": "CQA-HSF-9W-BS",
            "sku": "CQA-HSF-9W-BS",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-9W-BS.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808896226",
            "variantId": "67673808896226",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSSJZ-9W-BS",
            "label": "CQA-HSSJZ-9W-BS",
            "sku": "CQA-HSSJZ-9W-BS",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-9W-BS.jpg?v=1791769023",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808928994",
            "variantId": "67673808928994",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-D150-5W",
            "label": "CQA-PC-D150-5W",
            "sku": "CQA-PC-D150-5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-D150-5W_652bd63b-8d70-4bef-90d1-75a22e70eb1b.jpg?v=1787899945",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808961762",
            "variantId": "67673808961762",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-D200-5.5W",
            "label": "CQA-PC-D200-5.5W",
            "sku": "CQA-PC-D200-5.5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-D200-5.5W_35c5c14c-a4a9-4ca7-a28a-4ce83a5b1449.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808994530",
            "variantId": "67673808994530",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-FB220-5.5W",
            "label": "CQA-PC-FB220-5.5W",
            "sku": "CQA-PC-FB220-5.5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-FB220-5.5W.jpg?v=1791770329",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809027298",
            "variantId": "67673809027298",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQ-RXXTD02-12W",
            "label": "CQ-RXXTD02-12W",
            "sku": "CQ-RXXTD02-12W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQ-RXXTD02-12W_97def251-195f-4a5c-a55c-ec1c77933b01.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809060066",
            "variantId": "67673809060066",
            "allowedLightingModes": [
              "cw"
            ]
          }
        ],
        "vibrant": [
          {
            "id": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "label": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "sku": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808404706",
            "variantId": "67673808404706",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HW-YQPC15-13W-RGBCW",
            "label": "CQA-HW-YQPC15-13W-RGBCW",
            "sku": "CQA-HW-YQPC15-13W-RGBCW",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808437474",
            "variantId": "67673808437474",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSC-7W-RGBCW",
            "label": "CQA-HSC-7W-RGBCW",
            "sku": "CQA-HSC-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-RGBCW_2f902008-5aa1-4752-9380-47bd5a78b0ca.jpg?v=1787899944",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808601314",
            "variantId": "67673808601314",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-RGBCW",
            "label": "CQA-HSF-7W-RGBCW",
            "sku": "CQA-HSF-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-RGBCW_ef33020d-9304-45ab-862a-5b1303b16ea1.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808666850",
            "variantId": "67673808666850",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-RGBCW",
            "label": "CQA-HSSJZ-7W-RGBCW",
            "sku": "CQA-HSSJZ-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-RGBCW_f3eccaff-3812-4fae-95df-9beb06399cdf.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808732386",
            "variantId": "67673808732386",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSC-7W-BS-RGBCW",
            "label": "CQA-HSC-7W-BS-RGBCW",
            "sku": "CQA-HSC-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-BS-RGBCW.jpg?v=1791769025",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808765154",
            "variantId": "67673808765154",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-BS-RGBCW",
            "label": "CQA-HSF-7W-BS-RGBCW",
            "sku": "CQA-HSF-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-BS-RGBCW.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808797922",
            "variantId": "67673808797922",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-BS-RGBCW",
            "label": "CQA-HSSJZ-7W-BS-RGBCW",
            "sku": "CQA-HSSJZ-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-BS-RGBCW.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808830690",
            "variantId": "67673808830690",
            "allowedLightingModes": [
              "rgb"
            ]
          }
        ]
      },
      "tracks": []
    },
    "suspended": {
      "id": "suspended",
      "handle": "outdoor-suspended-light-color-bridge",
      "cartVariantId": "47819813093602",
      "pluginOptionSetId": "165143",
      "family": "color_bridge",
      "fixturesByShape": {
        "basic": [
          {
            "id": "CQA-HW-YQPC12-10W",
            "label": "CQA-HW-YQPC12-10W",
            "sku": "CQA-HW-YQPC12-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HW-YQPC12-10W_8b4011e6-d772-4150-bb08-2cb71ebd27c6.jpg?v=1787899933",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808339170",
            "variantId": "67673808339170",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HW-YQPC15-13W",
            "label": "CQA-HW-YQPC15-13W",
            "sku": "CQA-HW-YQPC15-13W",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808371938",
            "variantId": "67673808371938",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-SZ-10W",
            "label": "CQA-SZ-10W",
            "sku": "CQA-SZ-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-SZ-10W_1a4e68e1-de34-4325-8bf3-23d8831c58f4.jpg?v=1787899934",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808470242",
            "variantId": "67673808470242",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-XBJW-7W",
            "label": "CQA-XBJW-7W",
            "sku": "CQA-XBJW-7W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-XBJW-7W_cdd3c78c-dca0-4fa0-96dd-c1ba7f203345.jpg?v=1787899935",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808503010",
            "variantId": "67673808503010",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSB-9W",
            "label": "CQA-HSB-9W",
            "sku": "CQA-HSB-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSB-9W_b9add07a-10ad-45a2-b860-35074383e8ee.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808535778",
            "variantId": "67673808535778",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSC-9W",
            "label": "CQA-HSC-9W",
            "sku": "CQA-HSC-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-9W_634ae9e1-5c4d-4c21-8faf-00cebef62e18.jpg?v=1787899931",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808568546",
            "variantId": "67673808568546",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSF-9W",
            "label": "CQA-HSF-9W",
            "sku": "CQA-HSF-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-9W_0ec5abbc-6376-4fbf-a77c-654135f974af.jpg?v=1787899940",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808634082",
            "variantId": "67673808634082",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSSJZ-9W",
            "label": "CQA-HSSJZ-9W",
            "sku": "CQA-HSSJZ-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-9W_c7b0ab60-e47f-41b8-971f-e5480033d963.jpg?v=1787899938",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808699618",
            "variantId": "67673808699618",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-D150-5W",
            "label": "CQA-PC-D150-5W",
            "sku": "CQA-PC-D150-5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-D150-5W_652bd63b-8d70-4bef-90d1-75a22e70eb1b.jpg?v=1787899945",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808961762",
            "variantId": "67673808961762",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-D200-5.5W",
            "label": "CQA-PC-D200-5.5W",
            "sku": "CQA-PC-D200-5.5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-D200-5.5W_35c5c14c-a4a9-4ca7-a28a-4ce83a5b1449.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808994530",
            "variantId": "67673808994530",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-FB220-5.5W",
            "label": "CQA-PC-FB220-5.5W",
            "sku": "CQA-PC-FB220-5.5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-FB220-5.5W.jpg?v=1791770329",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809027298",
            "variantId": "67673809027298",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQ-RXXTD02-12W",
            "label": "CQ-RXXTD02-12W",
            "sku": "CQ-RXXTD02-12W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQ-RXXTD02-12W_97def251-195f-4a5c-a55c-ec1c77933b01.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809060066",
            "variantId": "67673809060066",
            "allowedLightingModes": [
              "cw"
            ]
          }
        ],
        "vibrant": [
          {
            "id": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "label": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "sku": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808404706",
            "variantId": "67673808404706",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HW-YQPC15-13W-RGBCW",
            "label": "CQA-HW-YQPC15-13W-RGBCW",
            "sku": "CQA-HW-YQPC15-13W-RGBCW",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808437474",
            "variantId": "67673808437474",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSC-7W-RGBCW",
            "label": "CQA-HSC-7W-RGBCW",
            "sku": "CQA-HSC-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-RGBCW_2f902008-5aa1-4752-9380-47bd5a78b0ca.jpg?v=1787899944",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808601314",
            "variantId": "67673808601314",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-RGBCW",
            "label": "CQA-HSF-7W-RGBCW",
            "sku": "CQA-HSF-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-RGBCW_ef33020d-9304-45ab-862a-5b1303b16ea1.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808666850",
            "variantId": "67673808666850",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-RGBCW",
            "label": "CQA-HSSJZ-7W-RGBCW",
            "sku": "CQA-HSSJZ-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-RGBCW_f3eccaff-3812-4fae-95df-9beb06399cdf.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808732386",
            "variantId": "67673808732386",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSC-7W-BS-RGBCW",
            "label": "CQA-HSC-7W-BS-RGBCW",
            "sku": "CQA-HSC-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-BS-RGBCW.jpg?v=1791769025",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808765154",
            "variantId": "67673808765154",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-BS-RGBCW",
            "label": "CQA-HSF-7W-BS-RGBCW",
            "sku": "CQA-HSF-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-BS-RGBCW.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808797922",
            "variantId": "67673808797922",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-BS-RGBCW",
            "label": "CQA-HSSJZ-7W-BS-RGBCW",
            "sku": "CQA-HSSJZ-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-BS-RGBCW.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808830690",
            "variantId": "67673808830690",
            "allowedLightingModes": [
              "rgb"
            ]
          }
        ]
      },
      "tracks": []
    },
    "mounted_hanging": {
      "id": "mounted_hanging",
      "handle": "outdoor-mounted-hanging-light-color-bridge",
      "cartVariantId": "47819816304866",
      "pluginOptionSetId": "159723",
      "family": "color_bridge",
      "fixturesByShape": {
        "basic": [
          {
            "id": "CQA-HW-YQPC12-10W",
            "label": "CQA-HW-YQPC12-10W",
            "sku": "CQA-HW-YQPC12-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HW-YQPC12-10W_8b4011e6-d772-4150-bb08-2cb71ebd27c6.jpg?v=1787899933",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808339170",
            "variantId": "67673808339170",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HW-YQPC15-13W",
            "label": "CQA-HW-YQPC15-13W",
            "sku": "CQA-HW-YQPC15-13W",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808371938",
            "variantId": "67673808371938",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-SZ-10W",
            "label": "CQA-SZ-10W",
            "sku": "CQA-SZ-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-SZ-10W_1a4e68e1-de34-4325-8bf3-23d8831c58f4.jpg?v=1787899934",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808470242",
            "variantId": "67673808470242",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-XBJW-7W",
            "label": "CQA-XBJW-7W",
            "sku": "CQA-XBJW-7W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-XBJW-7W_cdd3c78c-dca0-4fa0-96dd-c1ba7f203345.jpg?v=1787899935",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808503010",
            "variantId": "67673808503010",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSB-9W",
            "label": "CQA-HSB-9W",
            "sku": "CQA-HSB-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSB-9W_b9add07a-10ad-45a2-b860-35074383e8ee.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808535778",
            "variantId": "67673808535778",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSC-9W",
            "label": "CQA-HSC-9W",
            "sku": "CQA-HSC-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-9W_634ae9e1-5c4d-4c21-8faf-00cebef62e18.jpg?v=1787899931",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808568546",
            "variantId": "67673808568546",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSF-9W",
            "label": "CQA-HSF-9W",
            "sku": "CQA-HSF-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-9W_0ec5abbc-6376-4fbf-a77c-654135f974af.jpg?v=1787899940",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808634082",
            "variantId": "67673808634082",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSSJZ-9W",
            "label": "CQA-HSSJZ-9W",
            "sku": "CQA-HSSJZ-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-9W_c7b0ab60-e47f-41b8-971f-e5480033d963.jpg?v=1787899938",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808699618",
            "variantId": "67673808699618",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-D150-5W",
            "label": "CQA-PC-D150-5W",
            "sku": "CQA-PC-D150-5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-D150-5W_652bd63b-8d70-4bef-90d1-75a22e70eb1b.jpg?v=1787899945",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808961762",
            "variantId": "67673808961762",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-D200-5.5W",
            "label": "CQA-PC-D200-5.5W",
            "sku": "CQA-PC-D200-5.5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-D200-5.5W_35c5c14c-a4a9-4ca7-a28a-4ce83a5b1449.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808994530",
            "variantId": "67673808994530",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-FB220-5.5W",
            "label": "CQA-PC-FB220-5.5W",
            "sku": "CQA-PC-FB220-5.5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-FB220-5.5W.jpg?v=1791770329",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809027298",
            "variantId": "67673809027298",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQ-RXXTD02-12W",
            "label": "CQ-RXXTD02-12W",
            "sku": "CQ-RXXTD02-12W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQ-RXXTD02-12W_97def251-195f-4a5c-a55c-ec1c77933b01.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809060066",
            "variantId": "67673809060066",
            "allowedLightingModes": [
              "cw"
            ]
          }
        ],
        "vibrant": [
          {
            "id": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "label": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "sku": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808404706",
            "variantId": "67673808404706",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HW-YQPC15-13W-RGBCW",
            "label": "CQA-HW-YQPC15-13W-RGBCW",
            "sku": "CQA-HW-YQPC15-13W-RGBCW",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808437474",
            "variantId": "67673808437474",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSC-7W-RGBCW",
            "label": "CQA-HSC-7W-RGBCW",
            "sku": "CQA-HSC-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-RGBCW_2f902008-5aa1-4752-9380-47bd5a78b0ca.jpg?v=1787899944",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808601314",
            "variantId": "67673808601314",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-RGBCW",
            "label": "CQA-HSF-7W-RGBCW",
            "sku": "CQA-HSF-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-RGBCW_ef33020d-9304-45ab-862a-5b1303b16ea1.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808666850",
            "variantId": "67673808666850",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-RGBCW",
            "label": "CQA-HSSJZ-7W-RGBCW",
            "sku": "CQA-HSSJZ-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-RGBCW_f3eccaff-3812-4fae-95df-9beb06399cdf.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808732386",
            "variantId": "67673808732386",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSC-7W-BS-RGBCW",
            "label": "CQA-HSC-7W-BS-RGBCW",
            "sku": "CQA-HSC-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-BS-RGBCW.jpg?v=1791769025",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808765154",
            "variantId": "67673808765154",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-BS-RGBCW",
            "label": "CQA-HSF-7W-BS-RGBCW",
            "sku": "CQA-HSF-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-BS-RGBCW.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808797922",
            "variantId": "67673808797922",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-BS-RGBCW",
            "label": "CQA-HSSJZ-7W-BS-RGBCW",
            "sku": "CQA-HSSJZ-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-BS-RGBCW.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808830690",
            "variantId": "67673808830690",
            "allowedLightingModes": [
              "rgb"
            ]
          }
        ]
      },
      "tracks": []
    },
    "ceiling_hanging": {
      "id": "ceiling_hanging",
      "handle": "outdoor-ceiling-hanging-light-color-bridge",
      "cartVariantId": "47819817910498",
      "pluginOptionSetId": "159722",
      "family": "color_bridge",
      "fixturesByShape": {
        "basic": [
          {
            "id": "CQA-HW-YQPC12-10W",
            "label": "CQA-HW-YQPC12-10W",
            "sku": "CQA-HW-YQPC12-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HW-YQPC12-10W_8b4011e6-d772-4150-bb08-2cb71ebd27c6.jpg?v=1787899933",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808339170",
            "variantId": "67673808339170",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HW-YQPC15-13W",
            "label": "CQA-HW-YQPC15-13W",
            "sku": "CQA-HW-YQPC15-13W",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808371938",
            "variantId": "67673808371938",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-SZ-10W",
            "label": "CQA-SZ-10W",
            "sku": "CQA-SZ-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-SZ-10W_1a4e68e1-de34-4325-8bf3-23d8831c58f4.jpg?v=1787899934",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808470242",
            "variantId": "67673808470242",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-XBJW-7W",
            "label": "CQA-XBJW-7W",
            "sku": "CQA-XBJW-7W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-XBJW-7W_cdd3c78c-dca0-4fa0-96dd-c1ba7f203345.jpg?v=1787899935",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808503010",
            "variantId": "67673808503010",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSB-9W",
            "label": "CQA-HSB-9W",
            "sku": "CQA-HSB-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSB-9W_b9add07a-10ad-45a2-b860-35074383e8ee.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808535778",
            "variantId": "67673808535778",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSC-9W",
            "label": "CQA-HSC-9W",
            "sku": "CQA-HSC-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-9W_634ae9e1-5c4d-4c21-8faf-00cebef62e18.jpg?v=1787899931",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808568546",
            "variantId": "67673808568546",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSF-9W",
            "label": "CQA-HSF-9W",
            "sku": "CQA-HSF-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-9W_0ec5abbc-6376-4fbf-a77c-654135f974af.jpg?v=1787899940",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808634082",
            "variantId": "67673808634082",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSSJZ-9W",
            "label": "CQA-HSSJZ-9W",
            "sku": "CQA-HSSJZ-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-9W_c7b0ab60-e47f-41b8-971f-e5480033d963.jpg?v=1787899938",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808699618",
            "variantId": "67673808699618",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-D150-5W",
            "label": "CQA-PC-D150-5W",
            "sku": "CQA-PC-D150-5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-D150-5W_652bd63b-8d70-4bef-90d1-75a22e70eb1b.jpg?v=1787899945",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808961762",
            "variantId": "67673808961762",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-D200-5.5W",
            "label": "CQA-PC-D200-5.5W",
            "sku": "CQA-PC-D200-5.5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-D200-5.5W_35c5c14c-a4a9-4ca7-a28a-4ce83a5b1449.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808994530",
            "variantId": "67673808994530",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-PC-FB220-5.5W",
            "label": "CQA-PC-FB220-5.5W",
            "sku": "CQA-PC-FB220-5.5W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-PC-FB220-5.5W.jpg?v=1791770329",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809027298",
            "variantId": "67673809027298",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQ-RXXTD02-12W",
            "label": "CQ-RXXTD02-12W",
            "sku": "CQ-RXXTD02-12W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQ-RXXTD02-12W_97def251-195f-4a5c-a55c-ec1c77933b01.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809060066",
            "variantId": "67673809060066",
            "allowedLightingModes": [
              "cw"
            ]
          }
        ],
        "vibrant": [
          {
            "id": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "label": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "sku": "CQA-HW-YQPC12-10W-MS-RGBCW",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808404706",
            "variantId": "67673808404706",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HW-YQPC15-13W-RGBCW",
            "label": "CQA-HW-YQPC15-13W-RGBCW",
            "sku": "CQA-HW-YQPC15-13W-RGBCW",
            "imageUrl": "",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808437474",
            "variantId": "67673808437474",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSC-7W-RGBCW",
            "label": "CQA-HSC-7W-RGBCW",
            "sku": "CQA-HSC-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-RGBCW_2f902008-5aa1-4752-9380-47bd5a78b0ca.jpg?v=1787899944",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808601314",
            "variantId": "67673808601314",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-RGBCW",
            "label": "CQA-HSF-7W-RGBCW",
            "sku": "CQA-HSF-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-RGBCW_ef33020d-9304-45ab-862a-5b1303b16ea1.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808666850",
            "variantId": "67673808666850",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-RGBCW",
            "label": "CQA-HSSJZ-7W-RGBCW",
            "sku": "CQA-HSSJZ-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-RGBCW_f3eccaff-3812-4fae-95df-9beb06399cdf.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808732386",
            "variantId": "67673808732386",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSC-7W-BS-RGBCW",
            "label": "CQA-HSC-7W-BS-RGBCW",
            "sku": "CQA-HSC-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-BS-RGBCW.jpg?v=1791769025",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808765154",
            "variantId": "67673808765154",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-BS-RGBCW",
            "label": "CQA-HSF-7W-BS-RGBCW",
            "sku": "CQA-HSF-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-BS-RGBCW.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808797922",
            "variantId": "67673808797922",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-BS-RGBCW",
            "label": "CQA-HSSJZ-7W-BS-RGBCW",
            "sku": "CQA-HSSJZ-7W-BS-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-BS-RGBCW.jpg?v=1791769024",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808830690",
            "variantId": "67673808830690",
            "allowedLightingModes": [
              "rgb"
            ]
          }
        ]
      },
      "tracks": []
    },
    "wall_track": {
      "id": "wall_track",
      "handle": "outdoor-wall-track-light-lnt",
      "cartVariantId": "47819800379618",
      "pluginOptionSetId": "165141",
      "family": "lnt",
      "fixturesByShape": {
        "basic": [
          {
            "id": "LNT-HSC-W-9W",
            "label": "LNT-HSC-W-9W",
            "sku": "LNT-HSC-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-W-9W_d36cbaa4-a90b-409a-988c-76a151263d26.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809289442",
            "variantId": "67673809289442",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSC-9W",
            "label": "LNT-HSC-9W",
            "sku": "LNT-HSC-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-9W_8af253c3-ed25-4ac4-b932-04b2d480d23c.jpg?v=1787899937",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809354978",
            "variantId": "67673809354978",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSF-W-9W",
            "label": "LNT-HSF-W-9W",
            "sku": "LNT-HSF-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-W-9W_be931031-99f3-49b5-9fe8-a7a8c4a00e23.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809420514",
            "variantId": "67673809420514",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSF-9W",
            "label": "LNT-HSF-9W",
            "sku": "LNT-HSF-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-9W_257c1b01-99b4-4f36-aa0e-6f6c4ca9c75c.jpg?v=1787899937",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809486050",
            "variantId": "67673809486050",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSSJZ-W-9W",
            "label": "LNT-HSSJZ-W-9W",
            "sku": "LNT-HSSJZ-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-W-9W_6b31d522-39cc-4553-bb8c-2b68f69e2710.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809551586",
            "variantId": "67673809551586",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSSJZ-9W",
            "label": "LNT-HSSJZ-9W",
            "sku": "LNT-HSSJZ-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-9W_21ecef64-4571-4af2-86e1-9728e4ca744b.jpg?v=1787899938",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809617122",
            "variantId": "67673809617122",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-ZTSD-9W",
            "label": "LNT-ZTSD-9W",
            "sku": "LNT-ZTSD-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-ZTSD-9W_38e6f05a-95e3-4d9a-ab04-6abe4e5ad899.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809682658",
            "variantId": "67673809682658",
            "allowedLightingModes": [
              "cw"
            ]
          }
        ],
        "vibrant": [
          {
            "id": "LNT-HSC-7W-RGBCW-B",
            "label": "LNT-HSC-7W-RGBCW-B",
            "sku": "LNT-HSC-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-7W-RGBCW-B_b46f6bf1-72d4-4a70-96c7-de8dc7fe992d.jpg?v=1787899949",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809322210",
            "variantId": "67673809322210",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSC-7W-RGBCW-A",
            "label": "LNT-HSC-7W-RGBCW-A",
            "sku": "LNT-HSC-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-7W-RGBCW-A_533b8a1d-fc53-4ed2-98aa-28d547b776f6.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809387746",
            "variantId": "67673809387746",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSF-7W-RGBCW-B",
            "label": "LNT-HSF-7W-RGBCW-B",
            "sku": "LNT-HSF-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-7W-RGBCW-B_a8e6c73c-90ba-4454-882e-27665020b72f.jpg?v=1787899950",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809453282",
            "variantId": "67673809453282",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSF-7W-RGBCW-A",
            "label": "LNT-HSF-7W-RGBCW-A",
            "sku": "LNT-HSF-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-7W-RGBCW-A_b33851cb-197d-4748-972e-1bc210ed3dcb.jpg?v=1787899947",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809518818",
            "variantId": "67673809518818",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSSJZ-7W-RGBCW-B",
            "label": "LNT-HSSJZ-7W-RGBCW-B",
            "sku": "LNT-HSSJZ-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-7W-RGBCW-B_c0343c9e-c189-4532-9f64-035b0b51d7cb.jpg?v=1787899949",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809584354",
            "variantId": "67673809584354",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSSJZ-7W-RGBCW-A",
            "label": "LNT-HSSJZ-7W-RGBCW-A",
            "sku": "LNT-HSSJZ-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-7W-RGBCW-A_5958038a-8845-4733-9bf7-f037b0e7c702.jpg?v=1787899947",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809649890",
            "variantId": "67673809649890",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-ZTSD-7W-RGBCW",
            "label": "LNT-ZTSD-7W-RGBCW",
            "sku": "LNT-ZTSD-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-ZTSD-7W-RGBCW_bf238c36-0f23-4b90-a536-be5ee19c03e0.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809715426",
            "variantId": "67673809715426",
            "allowedLightingModes": [
              "rgb"
            ]
          }
        ]
      },
      "tracks": [
        {
          "id": "ZCHW-F-P-80",
          "label": "ZCHW-F-P-80",
          "sku": "ZCHW-F-P-80",
          "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/ZCHW-F-P-80_b51312f8-8415-409f-a069-d697120236ba.jpg?v=1787899948",
          "productHandle": "leaves-lnt",
          "cartVariantId": "67673810338018",
          "variantId": "67673810338018"
        },
        {
          "id": "ZCHW-Y-P-80",
          "label": "ZCHW-Y-P-80",
          "sku": "ZCHW-Y-P-80",
          "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/ZCHW-Y-P-80.jpg?v=1787899947",
          "productHandle": "leaves-lnt",
          "cartVariantId": "67673810370786",
          "variantId": "67673810370786"
        }
      ]
    },
    "floor_track": {
      "id": "floor_track",
      "handle": "outdoor-lnt-track-system",
      "cartVariantId": "47266789425378",
      "pluginOptionSetId": "150880",
      "family": "lnt",
      "fixturesByShape": {
        "basic": [
          {
            "id": "LNT-HSC-W-9W",
            "label": "LNT-HSC-W-9W",
            "sku": "LNT-HSC-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-W-9W_d36cbaa4-a90b-409a-988c-76a151263d26.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809289442",
            "variantId": "67673809289442",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSC-9W",
            "label": "LNT-HSC-9W",
            "sku": "LNT-HSC-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-9W_8af253c3-ed25-4ac4-b932-04b2d480d23c.jpg?v=1787899937",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809354978",
            "variantId": "67673809354978",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSF-W-9W",
            "label": "LNT-HSF-W-9W",
            "sku": "LNT-HSF-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-W-9W_be931031-99f3-49b5-9fe8-a7a8c4a00e23.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809420514",
            "variantId": "67673809420514",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSF-9W",
            "label": "LNT-HSF-9W",
            "sku": "LNT-HSF-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-9W_257c1b01-99b4-4f36-aa0e-6f6c4ca9c75c.jpg?v=1787899937",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809486050",
            "variantId": "67673809486050",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSSJZ-W-9W",
            "label": "LNT-HSSJZ-W-9W",
            "sku": "LNT-HSSJZ-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-W-9W_6b31d522-39cc-4553-bb8c-2b68f69e2710.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809551586",
            "variantId": "67673809551586",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSSJZ-9W",
            "label": "LNT-HSSJZ-9W",
            "sku": "LNT-HSSJZ-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-9W_21ecef64-4571-4af2-86e1-9728e4ca744b.jpg?v=1787899938",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809617122",
            "variantId": "67673809617122",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-ZTSD-9W",
            "label": "LNT-ZTSD-9W",
            "sku": "LNT-ZTSD-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-ZTSD-9W_38e6f05a-95e3-4d9a-ab04-6abe4e5ad899.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809682658",
            "variantId": "67673809682658",
            "allowedLightingModes": [
              "cw"
            ]
          }
        ],
        "vibrant": [
          {
            "id": "LNT-HSC-7W-RGBCW-B",
            "label": "LNT-HSC-7W-RGBCW-B",
            "sku": "LNT-HSC-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-7W-RGBCW-B_b46f6bf1-72d4-4a70-96c7-de8dc7fe992d.jpg?v=1787899949",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809322210",
            "variantId": "67673809322210",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSC-7W-RGBCW-A",
            "label": "LNT-HSC-7W-RGBCW-A",
            "sku": "LNT-HSC-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-7W-RGBCW-A_533b8a1d-fc53-4ed2-98aa-28d547b776f6.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809387746",
            "variantId": "67673809387746",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSF-7W-RGBCW-B",
            "label": "LNT-HSF-7W-RGBCW-B",
            "sku": "LNT-HSF-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-7W-RGBCW-B_a8e6c73c-90ba-4454-882e-27665020b72f.jpg?v=1787899950",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809453282",
            "variantId": "67673809453282",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSF-7W-RGBCW-A",
            "label": "LNT-HSF-7W-RGBCW-A",
            "sku": "LNT-HSF-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-7W-RGBCW-A_b33851cb-197d-4748-972e-1bc210ed3dcb.jpg?v=1787899947",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809518818",
            "variantId": "67673809518818",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSSJZ-7W-RGBCW-B",
            "label": "LNT-HSSJZ-7W-RGBCW-B",
            "sku": "LNT-HSSJZ-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-7W-RGBCW-B_c0343c9e-c189-4532-9f64-035b0b51d7cb.jpg?v=1787899949",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809584354",
            "variantId": "67673809584354",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSSJZ-7W-RGBCW-A",
            "label": "LNT-HSSJZ-7W-RGBCW-A",
            "sku": "LNT-HSSJZ-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-7W-RGBCW-A_5958038a-8845-4733-9bf7-f037b0e7c702.jpg?v=1787899947",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809649890",
            "variantId": "67673809649890",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-ZTSD-7W-RGBCW",
            "label": "LNT-ZTSD-7W-RGBCW",
            "sku": "LNT-ZTSD-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-ZTSD-7W-RGBCW_bf238c36-0f23-4b90-a536-be5ee19c03e0.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809715426",
            "variantId": "67673809715426",
            "allowedLightingModes": [
              "rgb"
            ]
          }
        ]
      },
      "trackChoice": "required",
      "tracks": [
        {
          "id": "ZCHW-F-P-800-278",
          "label": "ZCHW-F-P-800",
          "sizeLabel": "Size: 27.8*31*800mm",
          "trackValue": "ZCHW-F-P-800 Size: 27.8*31*800mm",
          "sku": "ZCHW-F-P-80",
          "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/ZCHW-F-P-80_b51312f8-8415-409f-a069-d697120236ba.jpg?v=1787899948",
          "productHandle": "leaves-lnt",
          "cartVariantId": "67673810338018",
          "variantId": "67673810338018",
          "priceSnapshot": 18
        },
        {
          "id": "ZCHW-F-P-800-415",
          "label": "ZCHW-F-P-800",
          "sizeLabel": "Size: 41.5*36*800mm",
          "trackValue": "ZCHW-F-P-800 Size: 41.5*36*800mm",
          "sku": "ZCHW-F-P-80",
          "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/ZCHW-F-P-80_b51312f8-8415-409f-a069-d697120236ba.jpg?v=1787899948",
          "productHandle": "leaves-lnt",
          "cartVariantId": "67673810338018",
          "variantId": "67673810338018",
          "priceSnapshot": 18
        }
      ]
    },
    "ceiling_track": {
      "id": "ceiling_track",
      "handle": "outdoor-ceiling-track-light-lnt",
      "cartVariantId": "47819807260898",
      "pluginOptionSetId": "165142",
      "family": "lnt",
      "fixturesByShape": {
        "basic": [
          {
            "id": "LNT-HSC-W-9W",
            "label": "LNT-HSC-W-9W",
            "sku": "LNT-HSC-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-W-9W_d36cbaa4-a90b-409a-988c-76a151263d26.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809289442",
            "variantId": "67673809289442",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSC-9W",
            "label": "LNT-HSC-9W",
            "sku": "LNT-HSC-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-9W_8af253c3-ed25-4ac4-b932-04b2d480d23c.jpg?v=1787899937",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809354978",
            "variantId": "67673809354978",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSF-W-9W",
            "label": "LNT-HSF-W-9W",
            "sku": "LNT-HSF-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-W-9W_be931031-99f3-49b5-9fe8-a7a8c4a00e23.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809420514",
            "variantId": "67673809420514",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSF-9W",
            "label": "LNT-HSF-9W",
            "sku": "LNT-HSF-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-9W_257c1b01-99b4-4f36-aa0e-6f6c4ca9c75c.jpg?v=1787899937",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809486050",
            "variantId": "67673809486050",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSSJZ-W-9W",
            "label": "LNT-HSSJZ-W-9W",
            "sku": "LNT-HSSJZ-W-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-W-9W_6b31d522-39cc-4553-bb8c-2b68f69e2710.jpg?v=1787899943",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809551586",
            "variantId": "67673809551586",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-HSSJZ-9W",
            "label": "LNT-HSSJZ-9W",
            "sku": "LNT-HSSJZ-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-9W_21ecef64-4571-4af2-86e1-9728e4ca744b.jpg?v=1787899938",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809617122",
            "variantId": "67673809617122",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "LNT-ZTSD-9W",
            "label": "LNT-ZTSD-9W",
            "sku": "LNT-ZTSD-9W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-ZTSD-9W_38e6f05a-95e3-4d9a-ab04-6abe4e5ad899.jpg?v=1787899942",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809682658",
            "variantId": "67673809682658",
            "allowedLightingModes": [
              "cw"
            ]
          }
        ],
        "vibrant": [
          {
            "id": "LNT-HSC-7W-RGBCW-B",
            "label": "LNT-HSC-7W-RGBCW-B",
            "sku": "LNT-HSC-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-7W-RGBCW-B_b46f6bf1-72d4-4a70-96c7-de8dc7fe992d.jpg?v=1787899949",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809322210",
            "variantId": "67673809322210",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSC-7W-RGBCW-A",
            "label": "LNT-HSC-7W-RGBCW-A",
            "sku": "LNT-HSC-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSC-7W-RGBCW-A_533b8a1d-fc53-4ed2-98aa-28d547b776f6.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809387746",
            "variantId": "67673809387746",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSF-7W-RGBCW-B",
            "label": "LNT-HSF-7W-RGBCW-B",
            "sku": "LNT-HSF-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-7W-RGBCW-B_a8e6c73c-90ba-4454-882e-27665020b72f.jpg?v=1787899950",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809453282",
            "variantId": "67673809453282",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSF-7W-RGBCW-A",
            "label": "LNT-HSF-7W-RGBCW-A",
            "sku": "LNT-HSF-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSF-7W-RGBCW-A_b33851cb-197d-4748-972e-1bc210ed3dcb.jpg?v=1787899947",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809518818",
            "variantId": "67673809518818",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSSJZ-7W-RGBCW-B",
            "label": "LNT-HSSJZ-7W-RGBCW-B",
            "sku": "LNT-HSSJZ-7W-RGBCW-B",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-7W-RGBCW-B_c0343c9e-c189-4532-9f64-035b0b51d7cb.jpg?v=1787899949",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809584354",
            "variantId": "67673809584354",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-HSSJZ-7W-RGBCW-A",
            "label": "LNT-HSSJZ-7W-RGBCW-A",
            "sku": "LNT-HSSJZ-7W-RGBCW-A",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-HSSJZ-7W-RGBCW-A_5958038a-8845-4733-9bf7-f037b0e7c702.jpg?v=1787899947",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809649890",
            "variantId": "67673809649890",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "LNT-ZTSD-7W-RGBCW",
            "label": "LNT-ZTSD-7W-RGBCW",
            "sku": "LNT-ZTSD-7W-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/LNT-ZTSD-7W-RGBCW_bf238c36-0f23-4b90-a536-be5ee19c03e0.jpg?v=1787899948",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809715426",
            "variantId": "67673809715426",
            "allowedLightingModes": [
              "rgb"
            ]
          }
        ]
      },
      "tracks": [
        {
          "id": "ZCHW-F-P-80",
          "label": "ZCHW-F-P-80",
          "sku": "ZCHW-F-P-80",
          "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/ZCHW-F-P-80_b51312f8-8415-409f-a069-d697120236ba.jpg?v=1787899948",
          "productHandle": "leaves-lnt",
          "cartVariantId": "67673810338018",
          "variantId": "67673810338018"
        },
        {
          "id": "ZCHW-Y-P-80",
          "label": "ZCHW-Y-P-80",
          "sku": "ZCHW-Y-P-80",
          "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/ZCHW-Y-P-80.jpg?v=1787899947",
          "productHandle": "leaves-lnt",
          "cartVariantId": "67673810370786",
          "variantId": "67673810370786"
        }
      ]
    },
    "ground_spike": {
      "id": "ground_spike",
      "handle": "outdoor-ground-spike-lightcolor-bridge",
      "cartVariantId": "47819818893538",
      "pluginOptionSetId": "159720",
      "family": "color_bridge",
      "fixturesByShape": {
        "basic": [
          {
            "id": "CQA-HW-YQPC12-10W",
            "label": "CQA-HW-YQPC12-10W",
            "sku": "CQA-HW-YQPC12-10W",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HW-YQPC12-10W_8b4011e6-d772-4150-bb08-2cb71ebd27c6.jpg?v=1787899933",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673808339170",
            "variantId": "67673808339170",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSC-9W-DC",
            "label": "CQA-HSC-9W-DC",
            "sku": "CQA-HSC-9W-DC",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-9W-DC_7f22be69-2992-4b30-957f-e84fcfde9e24.jpg?v=1787899931",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809092834",
            "variantId": "67673809092834",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSF-9W-DC",
            "label": "CQA-HSF-9W-DC",
            "sku": "CQA-HSF-9W-DC",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-9W-DC_1dc7a1ad-abc7-4c0c-a536-116e25357704.jpg?v=1787899931",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809158370",
            "variantId": "67673809158370",
            "allowedLightingModes": [
              "cw"
            ]
          },
          {
            "id": "CQA-HSSJZ-9W-DC",
            "label": "CQA-HSSJZ-9W-DC",
            "sku": "CQA-HSSJZ-9W-DC",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-9W-DC_338b1195-84e7-4300-a84b-e8c152a50b7a.jpg?v=1787899931",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809223906",
            "variantId": "67673809223906",
            "allowedLightingModes": [
              "cw"
            ]
          }
        ],
        "vibrant": [
          {
            "id": "CQA-HSC-7W-DC-RGBCW",
            "label": "CQA-HSC-7W-DC-RGBCW",
            "sku": "CQA-HSC-7W-DC-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSC-7W-DC-RGBCW2.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809125602",
            "variantId": "67673809125602",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSF-7W-DC-RGBCW",
            "label": "CQA-HSF-7W-DC-RGBCW",
            "sku": "CQA-HSF-7W-DC-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSF-7W-DC-RGBCW_7a8f2d93-ac73-49c7-be38-8a0e8de927ab.jpg?v=1787899945",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809191138",
            "variantId": "67673809191138",
            "allowedLightingModes": [
              "rgb"
            ]
          },
          {
            "id": "CQA-HSSJZ-7W-DC-RGBCW",
            "label": "CQA-HSSJZ-7W-DC-RGBCW",
            "sku": "CQA-HSSJZ-7W-DC-RGBCW",
            "imageUrl": "https://cdn.shopify.com/s/files/1/0790/1128/3170/files/CQA-HSSJZ-7W-DC-RGBCW_88424e28-a54b-462f-aec3-9d75fccf79b2.jpg?v=1787899946",
            "productHandle": "leaves-lighting",
            "cartVariantId": "67673809256674",
            "variantId": "67673809256674",
            "allowedLightingModes": [
              "rgb"
            ]
          }
        ]
      },
      "tracks": []
    }
  }
};
})(window);
